import {
  PatientPrivateOnboardRequest,
  PatientOnboardResponse,
  PatientMedicalAidOnboardRequest,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class OnboardApi {
  public onboardPrivate = async (
    request: PatientPrivateOnboardRequest
  ): Promise<PatientOnboardResponse> => {
    const result = await trpc.client.patient.createPrivatePatient.mutate(request);

    return result;
  };

  public onboardMedicalAid = async (
    request: PatientMedicalAidOnboardRequest
  ): Promise<PatientOnboardResponse> => {
    const result = await trpc.client.patient.createMedicalAidPatient.mutate(request);

    return result;
  };
}
